import React from 'react';
import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import { selectDepartmentIds } from '../features/departments/departmentsSlice';
import DeptContainer from '../components/DeptContainer';
import DeptLinks from '../components/DeptLinks';
import '../global-sass/main.scss';

const Widget = () => {
	const labels = useLabels();
	const departmentIds = useSelector(selectDepartmentIds);

	return (
		<>
			{departmentIds.length > 1 && <DeptLinks />}

			{departmentIds.length > 0 ? (
				departmentIds.map((departmentId) => (
					<DeptContainer
						departmentId={departmentId}
						key={departmentId}
					/>
				))
			) : (
				<div className="container-fluid mt-4">
					<div className="text-center mt-1">
						<p className="text-muted">
							{labels.get(
								'NO_DEPARTMENT_DATA_AVAILABLE_VERBIAGE'
							)}
						</p>
					</div>
				</div>
			)}
		</>
	);
};

export default Widget;
